import { useNavigate } from "react-router-dom";
import { buttonClass } from "@jkast90/kast-common/ui";
import { BugReportPage } from "../accountKit";
import dialogCss from "../styles/Dialog.module.css";
import styles from "./BugReport.module.css";

const CLASSES = {
  page: styles.page,
  title: styles.title,
  section: "kui-card",
  sectionTitle: styles.sectionTitle,
  back: buttonClass({ variant: "ghost" }),
  button: buttonClass({ variant: "secondary" }),
  primaryButton: buttonClass({ variant: "primary" }),
  input: dialogCss.input,
  label: styles.label,
  hint: "kui-hint",
  logButton: buttonClass({ variant: "secondary", size: "sm" }),
  logPrimaryButton: buttonClass({ variant: "primary", size: "sm" }),
};

/**
 * Report a bug through the shared page (@jkast90/kast-common). Reports go to
 * the kast-dev admin inbox, not homepage's API. The recent API calls, console
 * output and screens ride along; admins can see them first.
 */
export default function BugReport() {
  const navigate = useNavigate();
  return <BugReportPage onBack={() => navigate(-1)} classNames={CLASSES} />;
}
